var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"video-modal",style:(`height:${_vm.height}px`)},[_c('Player',{attrs:{"type":"youtube","id":_vm.videoId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }